import React from "react";
import {
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
  SummaryGrid,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
} from "./MonthlyReport.styles";
import { Savings } from "@mui/icons-material";
import { formatNumber } from "./MonthlyReport.utils";

const MonthlyReportFeesBreakdown = ({ summary: { total_fiat_tx_processing = "0.00", total_percent_tx_processing = "0.00", total_terminal_maintenance = "0.00", total_terminal_setup = "0.00", total_monthly_amount_peer_mid = "0.00" } = {} }) => {
  if (['0', '0.00', 0, null].includes(total_fiat_tx_processing) && 
    ['0', '0.00', 0, null].includes(total_percent_tx_processing) && 
    ['0', '0.00', 0, null].includes(total_terminal_maintenance) && 
    ['0', '0.00', 0, null].includes(total_terminal_setup) && 
    ['0', '0.00', 0, null].includes(total_monthly_amount_peer_mid)
  ) {
    return null;
  }

  return (
    <GridItem xs={12} padding="0 0 15px 0">
      <DataCard>
        <DataCardHeader>
          <Savings color="primary" />
          <DataCardTitle>Net Residual Breakdown</DataCardTitle>
        </DataCardHeader>
        <SummaryGrid spacing={1}>
          {!['0', '0.00', 0, null].includes(total_fiat_tx_processing) && (
            <GridItem xs={12} sm={6} md={4}>
              <SummaryItem>
                <SummaryLabel>MDR Revenue</SummaryLabel>
                <SummaryValue>${formatNumber(total_percent_tx_processing)}</SummaryValue>
              </SummaryItem>
            </GridItem>
          )}
          {!['0', '0.00', 0, null].includes(total_monthly_amount_peer_mid) && (
            <GridItem xs={12} sm={6} md={4}>
              <SummaryItem>
                <SummaryLabel>Monthly MID Fee</SummaryLabel>
                <SummaryValue>${formatNumber(total_monthly_amount_peer_mid)}</SummaryValue>
              </SummaryItem>
            </GridItem>
          )}
          {!['0', '0.00', 0, null].includes(total_fiat_tx_processing) && (
            <GridItem xs={12} sm={6} md={4}>
            <SummaryItem>
              <SummaryLabel>Processing Fee</SummaryLabel>
                <SummaryValue>${formatNumber(total_fiat_tx_processing)}</SummaryValue>
              </SummaryItem>
            </GridItem>
          )}
          {!['0', '0.00', 0, null].includes(total_terminal_maintenance) && (
            <GridItem xs={12} sm={6} md={4}>
              <SummaryItem>
                <SummaryLabel>Terminal Maintenance</SummaryLabel>
                <SummaryValue>${formatNumber(total_terminal_maintenance)}</SummaryValue>
              </SummaryItem>
            </GridItem>
          )}
          {!['0', '0.00', 0, null].includes(total_terminal_setup) && (
            <GridItem xs={12} sm={6} md={4}>
              <SummaryItem>
                <SummaryLabel>Terminal Setup</SummaryLabel>
                <SummaryValue>${formatNumber(total_terminal_setup)}</SummaryValue>
              </SummaryItem>
            </GridItem>
          )}
        </SummaryGrid>
      </DataCard>
    </GridItem>
  );
};

export default MonthlyReportFeesBreakdown;

